/**
 * Joins the main title with the part number and part name into a single label,
 * e.g. "Velká kniha o kočkách. 3. Perské kočky". Blank parts are skipped.
 */
export var formatTitleWithParts = function (title) {
    return [title.mainTitle, title.partNumber, title.partName]
        .map(function (part) { return part === null || part === void 0 ? void 0 : part.trim(); })
        .filter(function (part) { return !!part; })
        .join(". ");
};
